<template>
  <div v-loading="loading">
    <div v-if="editModel">
      <el-form
        ref="form"
        :size="$xUISize"
        :model="editModel"
        :rules="editRules"
        @submit.native.prevent
        label-width="auto"
        label-position="top"
      >
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <el-form-item>
              <el-button
                type="primary"
                :loading="editSubmit"
                @submit.native.prevent
                @click="submitClick"
              >
                保存
              </el-button>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>关联其他商品</span>
            </div>
            <el-form-item label="SPU名称" prop="goodsSpuName" key="goodsSpuName">
              <el-input
                placeholder="请输入SPU名称"
                v-model="editModel.goodsSpuName"
              ></el-input>
            </el-form-item>
            <el-form-item label="SPU_CODE" prop="goodsSpuCode" key="goodsSpuCode">
              <el-input
                placeholder="请输入SPU_CODE"
                v-model="editModel.goodsSpuCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="SKU名称" prop="goodsSkuName" key="goodsSkuName">
              <el-input
                placeholder="请输入SKU名称"
                v-model="editModel.goodsSkuName"
              ></el-input>
            </el-form-item>
            <el-form-item label="SKU_CODE" prop="goodsSkuCode" key="goodsSkuCode">
              <el-input
                placeholder="请输入SKU_CODE"
                v-model="editModel.goodsSkuCode"
              ></el-input>
            </el-form-item>
            <el-form-item label="规格列表" prop="specGoodsList">
              <div>
                <goods-sku-select :multipleable="true" :excludeGuids="specExcludeGuids">
                  <template slot="info-append" slot-scope="scope">
                    <div style="margin-top: 10px">
                      <template v-if="getSpecItemBySkuGuid(scope.info.guid)">
                        <el-button
                          size="small"
                          type="danger"
                          @click="removeSpecClick(getSpecItemBySkuGuid(scope.info.guid))"
                        >
                          移出清单
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleAddSpecItem(scope.info)"
                        >
                          添加到清单
                        </el-button>
                      </template>
                    </div>
                  </template>
                </goods-sku-select>
                <el-table
                  stripe
                  v-if="editModel.specGoodsList && editModel.specGoodsList.length > 0"
                  :data="editModel.specGoodsList"
                  :cell-class-name="specDelLine"
                  :size="$xUISize"
                  style="width: 100%; margin-top: 10px"
                >
                  <el-table-column label="商品信息" min-width="380px">
                    <template slot-scope="scope">
                      <div style="margin-right: 10px">
                        <goods-sku-info :skuInfo="scope.row.specSkuInfo" />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        v-if="!scope.row.guid"
                        @click="removeSpecClick(scope.row)"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="scope.row.guid"
                        :type="scope.row.isDelete ? 'primary' : 'danger'"
                        :underline="false"
                        @click="deleteSpecClick(scope.row)"
                      >
                        {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="color: #999999; font-size: 14px; margin-top: 20px">
                  * 认真添加商品的多规格选项，丰富商品展示
                </div>
              </div>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 5px 20px">
            <div class="goods-form-title">
              <span>活动标签</span>
            </div>
            <el-form-item label="活动标签" prop="tagLabel" key="tagLabel">
              <el-select
                style="width: 100%"
                v-model="editModel.tagLabel"
                placeholder="请选择活动标签"
              >
                <el-option label="不标记" value=""> </el-option>
                <el-option label="爆款活动" value="爆款活动"> </el-option>
                <el-option label="划线活动" value="划线活动"> </el-option>
                <el-option label="滞销活动" value="滞销活动"> </el-option>
                <el-option label="临期商品" value="临期商品"> </el-option>
                <el-option label="回捞活动" value="回捞活动"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="其他标签" prop="otherLabel">
              <el-input
                placeholder="请输入其他标签"
                maxlength="20"
                v-model="editModel.otherLabel"
              ></el-input>
            </el-form-item>
            <el-form-item label="颜色标签" prop="optColor">
              <el-color-picker
                v-model="editModel.optColor"
                :predefine="predefineColors"
              ></el-color-picker>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 5px 20px">
            <div class="goods-form-title">
              <span>基础属性</span>
            </div>
            <el-form-item label="商品标题" prop="goodsTitle" key="goodsTitle">
              <el-input
                placeholder="请输入商品标题"
                v-model="editModel.goodsTitle"
              ></el-input>
              <span style="color: #919191">
                建议命名形式为“品牌+品名+商品规格+卖点”，示例: “农夫山泉 矿泉水 550ml
                天然弱碱性富含矿物质”。规范命名有利于提升销量
              </span>
            </el-form-item>
            <el-form-item label="商品分类" prop="classifyIds">
              <goods-classify-group v-model="editModel.classifyIds" :clearable="true" />
              <span style="color: #919191">
                可关联到1-10个分类，分类数大于10时，仅保留前10个分类
              </span>
            </el-form-item>
            <el-form-item label="三级分类标签" prop="classifyTag">
              <el-input
                placeholder="请输入三级分类标签"
                maxlength="20"
                v-model="editModel.classifyTag"
              ></el-input>
            </el-form-item>
            <el-form-item label="成分标签" prop="productTag1">
              <el-input
                placeholder="请输入成分标签"
                maxlength="20"
                v-model="editModel.productTag1"
              ></el-input>
            </el-form-item>
            <el-form-item label="销售标签" prop="productTag2">
              <el-select
                style="width: 100%"
                v-model="editModel.productTag2"
                placeholder="请选择销售标签"
              >
                <el-option label="不标记" value=""> </el-option>
                <el-option label="一般推荐" value="一般推荐"> </el-option>
                <el-option label="重点推荐" value="重点推荐"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="采购标签" prop="productTag3">
              <el-select
                style="width: 100%"
                v-model="editModel.productTag3"
                placeholder="请选择采购标签"
              >
                <el-option label="不标记" value=""> </el-option>
                <el-option label="关注" value="关注"> </el-option>
                <el-option label="归档" value="归档"> </el-option>
                <el-option label="合并" value="合并"> </el-option>
                <el-option label="入仓" value="入仓"> </el-option>
                <el-option label="删除" value="删除"> </el-option>
                <el-option label="淘汰" value="淘汰"> </el-option>
                <el-option label="新品" value="新品"> </el-option>
                <el-option label="正常" value="正常"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品卖点" prop="sellingPoint">
              <el-input
                placeholder="请输入20字以内的商品卖点"
                maxlength="20"
                v-model="editModel.sellingPoint"
              ></el-input>
            </el-form-item>
          </div>
        </el-card>

        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>规格型号与定价</span>
            </div>
            <el-form-item label="计量单位" prop="goodsUnit" key="goodsUnit">
              <el-select
                style="width: 100%"
                v-model="editModel.goodsUnit"
                placeholder="请选择计量单位"
              >
                <el-option label="份" value="份"> </el-option>
                <el-option label="件" value="件"> </el-option>
                <el-option label="个" value="个"> </el-option>
                <el-option label="只" value="只"> </el-option>
                <el-option label="瓶" value="瓶"> </el-option>
                <el-option label="罐" value="罐"> </el-option>
                <el-option label="袋" value="袋"> </el-option>
                <el-option label="盒" value="盒"> </el-option>
                <el-option label="桶" value="桶"> </el-option>
                <el-option label="包" value="包"> </el-option>
                <el-option label="箱" value="箱"> </el-option>
                <el-option label="支" value="支"> </el-option>
                <el-option label="片" value="片"> </el-option>
                <el-option label="条" value="条"> </el-option>
                <el-option label="粒" value="粒"> </el-option>
                <el-option label="颗" value="颗"> </el-option>
                <el-option label="克" value="克"> </el-option>
                <el-option label="千克" value="千克"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="零售单价（单位：元）"
              prop="retailPrice"
              key="retailPrice"
            >
              <el-input
                type="number"
                v-model="editModel.retailPrice"
                placeholder="请输入零售单价"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动价格" prop="originalPrice" key="originalPrice">
              <el-input
                type="number"
                v-model="editModel.originalPrice"
                placeholder="请输入活动价格"
              ></el-input>
            </el-form-item>
            <el-form-item label="价格标签" prop="priceTagLabel">
              <el-input
                placeholder="请输入价格标签"
                v-model="editModel.priceTagLabel"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位数量" prop="unitQuantity" key="unitQuantity">
              <el-input
                type="number"
                v-model="editModel.unitQuantity"
                placeholder="请输入单位数量"
              ></el-input>
              <span style="color: #919191">
                商品的入库/出库/销售数量必须是单位数量的倍数，默认为1
              </span>
            </el-form-item>
            <el-form-item label="起购数量" prop="minQuantity" key="minQuantity">
              <el-input
                type="number"
                v-model="editModel.minQuantity"
                placeholder="请输入起购数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品条码" prop="goodsUpc">
              <el-input
                placeholder="请输入商品条码"
                v-model="editModel.goodsUpc"
              ></el-input>
            </el-form-item>
            <el-form-item label="拓展条码" prop="extrasUpc">
              <el-input
                type="textarea"
                v-model="editModel.extrasUpc"
                :rows="2"
                maxlength="256"
                placeholder="输入拓展的条码"
                show-word-limit
              ></el-input>
              <span style="color: #919191"> 拓展条码仅适用于多条码商品查询 </span>
            </el-form-item>
            <el-form-item label="预估重量(单位：克)" prop="weight" key="weight">
              <el-input
                type="number"
                v-model="editModel.weight"
                placeholder="请输入预估重量"
              ></el-input>
              <span style="color: #919191"> 预估重量将用于配送费/运费的估算 </span>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>详细信息</span>
            </div>
            <image-download
              v-if="editModel.guid"
              :imageList="[editModel.image]"
              :imageFilePrefix="editModel.guid + '_主图'"
              :buttonText="'下载主图'"
            />
            <image-download
              v-if="editModel.guid"
              :imageList="[editModel.detail]"
              :imageFilePrefix="editModel.guid + '_详情图'"
              :buttonText="'下载详情图'"
            />
            <el-form-item label="商品主图" prop="image">
              <x-upload
                type="image"
                imageAlign="start"
                :fileCount="8"
                :fileSize="10 * 1024"
                :imageViewWidth="180"
                :imageViewHeight="180"
                v-model="editModel.image"
              ></x-upload>
              <span style="color: #919191">
                建议图片清晰、非翻拍、白底，最多上传8张图。高质量图片有利于提升销量
              </span>
            </el-form-item>
            <el-form-item label="商品详情" prop="detail">
              <x-upload
                type="image"
                imageAlign="start"
                :fileCount="20"
                :fileSize="5 * 1024"
                :imageViewWidth="180"
                :imageViewHeight="240"
                v-model="editModel.detail"
              ></x-upload>
              <span style="color: #919191">
                建议图片宽度≥640像素、高度≤960像素; 单张图片5MB以内;
                最多可上传20张。图片详情可使顾客更好地了解商品，进而提升商品销量
              </span>
            </el-form-item>
            <el-form-item label="备注说明" prop="optRemark">
              <el-input
                type="textarea"
                v-model="editModel.optRemark"
                :rows="4"
                maxlength="256"
                placeholder="输入备注说明内容"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>商品属性</span>
            </div>
            <el-form-item label="商品类型" prop="goodsType" key="goodsType">
              <el-radio-group v-model="editModel.goodsType">
                <el-radio label="default">普通商品</el-radio>
                <el-radio label="veterinary">兽用药品</el-radio>
              </el-radio-group>
              <div style="color: #919191" v-if="editModel.goodsType == 'veterinary'">
                <span style="margin-right: 10px">
                  * 扫描兽药追溯二维码可快速录入兽药基础信息
                </span>
                <el-link
                  :underline="false"
                  style="color: #3399ff"
                  @click="vetZsmVisible = true"
                >
                  追溯码查询导入
                </el-link>
              </div>
            </el-form-item>
            <template v-if="editModel.goodsType == 'veterinary'">
              <el-form-item label="通用名称" prop="genericName">
                <el-input
                  placeholder="请输入通用名称"
                  v-model="editModel.genericName"
                ></el-input>
              </el-form-item>
              <el-form-item label="批准文号" prop="approvalNum">
                <el-input
                  placeholder="请输入批准文号"
                  v-model="editModel.approvalNum"
                ></el-input>
              </el-form-item>
              <el-form-item label="生产厂商" prop="manufacturer" key="manufacturer">
                <el-input
                  placeholder="请输入生产厂商"
                  v-model="editModel.manufacturer"
                ></el-input>
              </el-form-item>
              <el-form-item label="药品类型" prop="drugType">
                <el-radio-group v-model="editModel.drugType">
                  <el-radio label="处方药">处方药</el-radio>
                  <el-radio label="非处方药">非处方药</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="药品剂型" prop="drugDosage" key="drugDosage">
                <el-input
                  placeholder="请输入药品剂型"
                  v-model="editModel.drugDosage"
                ></el-input>
              </el-form-item>
              <el-form-item label="药品规格" prop="drugSpec" key="drugSpec">
                <el-input
                  placeholder="请输入药品规格"
                  v-model="editModel.drugSpec"
                ></el-input>
              </el-form-item>
              <el-form-item label="药品名称" prop="drugName" key="drugName">
                <el-input
                  placeholder="请输入药品名称"
                  v-model="editModel.drugName"
                ></el-input>
              </el-form-item>
              <el-form-item label="国产/进口" prop="domesticProduction">
                <el-radio-group v-model="editModel.domesticProduction">
                  <el-radio label="国产">国产</el-radio>
                  <el-radio label="进口">进口</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="药品类别" prop="drugClassify">
                <el-input
                  placeholder="请输入药品类别"
                  v-model="editModel.drugClassify"
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item label="品牌名称" prop="brandName">
              <goods-brand-select v-model="editModel.brandIds" :clearable="true" />
            </el-form-item>
            <el-form-item label="商品产地" prop="placeProduction">
              <el-input
                placeholder="请输入商品产地"
                maxlength="20"
                v-model="editModel.placeProduction"
              ></el-input>
            </el-form-item>
            <el-form-item label="适用阶段" prop="applicableStage">
              <el-input
                placeholder="请输入的适用阶段"
                maxlength="256"
                v-model="editModel.applicableStage"
              ></el-input>
            </el-form-item>
            <el-form-item label="适用症状" prop="applicableSymptoms">
              <el-input
                placeholder="请输入的适用症状"
                maxlength="256"
                v-model="editModel.applicableSymptoms"
              ></el-input>
            </el-form-item>
            <el-form-item label="用法用量" prop="usageDosage" key="usageDosage">
              <el-input
                type="textarea"
                v-model="editModel.usageDosage"
                :rows="2"
                maxlength="256"
                placeholder="请输入用法用量"
                show-word-limit
              ></el-input>
              <span style="color: #919191">
                建议商品的用法用量信息，如：每日3次，每次1粒
              </span>
            </el-form-item>
            <el-form-item label="使用说明" prop="instructions">
              <x-upload
                type="image"
                imageAlign="start"
                :fileCount="10"
                :fileSize="5 * 1024"
                :imageViewWidth="240"
                :imageViewHeight="180"
                v-model="editModel.instructions"
              ></x-upload>
              <span style="color: #919191">
                可使顾客更好地了解商品使用说明，进而提升商品销量
              </span>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>可拆出以下商品</span>
            </div>
            <el-form-item label="拆零产出" prop="splitOutputList">
              <div>
                <goods-sku-select
                  :multipleable="true"
                  :excludeGuids="splitOutputExcludeGuids"
                >
                  <template slot="info-append" slot-scope="scope">
                    <div style="margin-top: 10px">
                      <template v-if="getSplitOutputItemBySkuGuid(scope.info.guid)">
                        <el-input-number
                          v-model="
                            getSplitOutputItemBySkuGuid(scope.info.guid).outputCount
                          "
                          style="width: 120px; margin-right: 10px"
                          size="small"
                          :min="1"
                        >
                        </el-input-number>
                        <el-button
                          size="small"
                          type="danger"
                          @click="
                            removeSplitOutputClick(
                              getSplitOutputItemBySkuGuid(scope.info.guid)
                            )
                          "
                        >
                          移出清单
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleAddSplitOutputItem(scope.info)"
                        >
                          添加到清单
                        </el-button>
                      </template>
                    </div>
                  </template>
                </goods-sku-select>
                <el-table
                  stripe
                  v-if="editModel.splitOutputList && editModel.splitOutputList.length > 0"
                  :data="editModel.splitOutputList"
                  :cell-class-name="splitOutputDelLine"
                  :size="$xUISize"
                  style="width: 100%; margin-top: 10px"
                >
                  <el-table-column label="商品信息" min-width="380px">
                    <template slot-scope="scope">
                      <div style="margin-right: 10px">
                        <goods-sku-info :skuInfo="scope.row.outputSkuInfo" />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="拆出数量" width="180px">
                    <template slot-scope="scope">
                      <el-input-number
                        :disabled="!!scope.row.isDelete"
                        v-model="scope.row.outputCount"
                        style="width: 120px; margin-right: 10px"
                        size="small"
                        :min="1"
                      >
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        v-if="!scope.row.guid"
                        @click="removeSplitOutputClick(scope.row)"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="scope.row.guid"
                        :type="scope.row.isDelete ? 'primary' : 'danger'"
                        :underline="false"
                        @click="deleteSplitOutputClick(scope.row)"
                      >
                        {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="color: #999999; font-size: 14px; margin-top: 20px">
                  * 进行商品拆零操作时，请务必遵循标准流程，保证商品的完整性与质量。
                </div>
              </div>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>可由以下商品拆出</span>
            </div>
            <el-form-item label="拆零消耗" prop="splitConsumeList">
              <div>
                <goods-sku-select
                  :multipleable="true"
                  :excludeGuids="splitConsumeExcludeGuids"
                >
                  <template slot="info-append" slot-scope="scope">
                    <div style="margin-top: 10px">
                      <template v-if="getSplitConsumeItemBySkuGuid(scope.info.guid)">
                        <el-input-number
                          v-model="
                            getSplitConsumeItemBySkuGuid(scope.info.guid).outputCount
                          "
                          style="width: 120px; margin-right: 10px"
                          size="small"
                          :min="1"
                        >
                        </el-input-number>
                        <el-button
                          size="small"
                          type="danger"
                          @click="
                            removeSplitConsumeClick(
                              getSplitConsumeItemBySkuGuid(scope.info.guid)
                            )
                          "
                        >
                          移出清单
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button
                          size="small"
                          type="primary"
                          @click="handleAddSplitConsumeItem(scope.info)"
                        >
                          添加到清单
                        </el-button>
                      </template>
                    </div>
                  </template>
                </goods-sku-select>
                <el-table
                  stripe
                  v-if="
                    editModel.splitConsumeList && editModel.splitConsumeList.length > 0
                  "
                  :data="editModel.splitConsumeList"
                  :cell-class-name="splitConsumeDelLine"
                  :size="$xUISize"
                  style="width: 100%; margin-top: 10px"
                >
                  <el-table-column label="商品信息" min-width="380px">
                    <template slot-scope="scope">
                      <div style="margin-right: 10px">
                        <goods-sku-info :skuInfo="scope.row.consumeSkuInfo" />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="拆出数量" width="180px">
                    <template slot-scope="scope">
                      <el-input-number
                        :disabled="!!scope.row.isDelete"
                        v-model="scope.row.outputCount"
                        style="width: 120px; margin-right: 10px"
                        size="small"
                        :min="1"
                      >
                      </el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        v-if="!scope.row.guid"
                        @click="removeSplitConsumeClick(scope.row)"
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="scope.row.guid"
                        :type="scope.row.isDelete ? 'primary' : 'danger'"
                        :underline="false"
                        @click="deleteSplitConsumeClick(scope.row)"
                      >
                        {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="color: #999999; font-size: 14px; margin-top: 20px">
                  * 进行商品拆零操作时，请务必遵循标准流程，保证商品的完整性与质量。
                </div>
              </div>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover" style="margin-bottom: 12px">
          <div style="padding: 10px 20px">
            <div class="goods-form-title">
              <span>其他属性</span>
            </div>
            <el-form-item label="商品类目" prop="categoryGuid">
              <goods-category-select v-model="editModel.categoryGuid" />
            </el-form-item>
            <el-form-item label="显示属性" prop="optTop">
              <el-radio-group v-model="editModel.optTop">
                <el-radio :label="0">默认</el-radio>
                <el-radio :label="1">置顶</el-radio>
                <el-radio :label="-1">置底</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="拆零可直接出入库" prop="optSplitInbound">
              <el-radio-group v-model="editModel.optSplitInbound">
                <el-radio :label="0">关闭</el-radio>
                <el-radio :label="1">开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-card>
        <el-card shadow="hover">
          <div style="padding: 10px 20px">
            <el-form-item>
              <el-button
                type="primary"
                :loading="editSubmit"
                @submit.native.prevent
                @click="submitClick"
              >
                保存
              </el-button>
            </el-form-item>
          </div>
        </el-card>
      </el-form>
      <el-dialog
        top="30px"
        width="600px"
        append-to-body
        title="兽药追溯信息"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="vetZsmVisible"
      >
        <div v-loading="vetZsmLoading">
          <div style="margin: 0px 20px">
            <el-form
              :model="{}"
              :size="$xUISize"
              @submit.native.prevent
              label-width="auto"
              label-position="top"
            >
              <el-form-item label="兽药追溯码">
                <el-input
                  :rows="2"
                  type="textarea"
                  v-model="vetZsmCode"
                  placeholder="请输入兽药追溯码"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="default"
                  :loading="vetZsmLoading"
                  :disabled="vetZsmLoading"
                  @submit.native.prevent
                  @click="getVetZsmInfo"
                >
                  查询
                </el-button>
                <el-button
                  type="primary"
                  v-if="vetZsmInfo"
                  @submit.native.prevent
                  @click="updateSkuInfoByVetZsmClick"
                >
                  插入到商品信息
                </el-button>
              </el-form-item>
            </el-form>
            <div v-if="vetZsmInfo">
              <div style="margin-bottom: 10px">
                根据追溯码内容，为您查询到以下兽药信息，是否插入到商品信息中
              </div>
              <vet-zsm-info :simpleMode="true" :zsmInfo="vetZsmInfo" />
            </div>
            <div v-else style="min-height: 240px">
              <el-empty
                v-if="!vetZsmLoading"
                :description="vetZsmErrorMsg || '输入兽药追溯码查询'"
                :image-size="100"
              >
                <el-button v-if="vetZsmErrorMsg" @click="getVetZsmInfo" size="small">
                  重新加载
                </el-button>
              </el-empty>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-card v-else-if="!loading" shadow="hover">
      <el-empty :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}

.goods-form-title {
  color: #919191;
  margin-bottom: 10px;
  font-size: 16px;
}
</style>

<script>
import customerSupplierSelect from "../../../../components/business/customerSupplierSelect.vue";
import goodsBrandSelect from "../../../../components/business/goodsBrandSelect.vue";
import goodsCategorySelect from "../../../../components/business/goodsCategorySelect.vue";
import goodsClassifyGroup from "../../../../components/business/goodsClassifyGroup.vue";
import GoodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import GoodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";
import vetZsmInfo from "../../../../components/business/vetZsmInfo.vue";
import ImageDownload from "./_image_download.vue";

const defaultModel = {
  categoryGuid: "",
  tempSpuId: "",
  tempSkuName: "",
  goodsType: "default",
  goodsTitle: "",
  goodsUnit: "份",
  goodsSpec: "",
  goodsUpc: "",
  extrasUpc: "",
  productName: "",
  approvalNum: "",
  genericName: "",
  manufacturer: "",
  drugType: "",
  drugName: "",
  drugSpec: "",
  drugDosage: "",
  retailPrice: "",
  originalPrice: "",
  brandIds: "",
  classifyIds: "",
  minQuantity: "1",
  unitQuantity: "1",
  domesticProduction: "国产",
  weight: "",
  optColor: "",
  optTop: 0,
  optSplitInbound: 0,
  optStatus: 1,
  splitConsumeList: [],
  splitOutputList: [],
  specGoodsList: [],
};

export default {
  components: {
    vetZsmInfo,
    goodsClassifyGroup,
    customerSupplierSelect,
    goodsCategorySelect,
    goodsBrandSelect,
    GoodsSkuSelect,
    GoodsSkuInfo,
    ImageDownload,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    specExcludeGuids() {
      let guids = [];
      if (this.editModel && this.editModel.guid) {
        guids.push(this.editModel.guid);
      }
      if (this.editModel && this.editModel.specGoodsList) {
        guids.push(
          ...this.editModel.specGoodsList
            .filter((item) => {
              return !item.guid;
            })
            .map((i) => {
              return i.specSkuGuid;
            })
        );
      }
      return guids;
    },
    splitConsumeExcludeGuids() {
      let guids = [];
      if (this.editModel && this.editModel.guid) {
        guids.push(this.editModel.guid);
      }
      if (this.editModel && this.editModel.splitConsumeList) {
        guids.push(
          ...this.editModel.splitConsumeList
            .filter((item) => {
              return !item.guid;
            })
            .map((i) => {
              return i.outputSkuGuid;
            })
        );
      }
      return guids;
    },
    splitOutputExcludeGuids() {
      let guids = [];
      if (this.editModel && this.editModel.guid) {
        guids.push(this.editModel.guid);
      }
      if (this.editModel && this.editModel.splitOutputList) {
        guids.push(
          ...this.editModel.splitOutputList
            .filter((item) => {
              return !item.guid;
            })
            .map((i) => {
              return i.outputSkuGuid;
            })
        );
      }
      return guids;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      vetZsmCode: "",
      vetZsmVisible: false,
      vetZsmLoading: false,
      vetZsmErrorMsg: false,
      vetZsmInfo: null,
      predefineColors: ["#F65950", "#F5C208", "#40CB55", "#177DF5", "#9F4FC7", "#97979D"],
      editSubmit: false,
      editModel: null,
      editRules: {
        goodsTitle: [
          {
            required: true,
            message: "请输入商品标题",
            trigger: "change",
          },
        ],
        goodsType: [
          {
            required: true,
            message: "请选择商品类型",
            trigger: "change",
          },
        ],
        genericName: [
          {
            required: true,
            message: "请输入通用名称",
            trigger: "change",
          },
        ],
        approvalNum: [
          {
            required: true,
            message: "请输入批准文号",
            trigger: "change",
          },
        ],
        manufacturer: [
          {
            required: true,
            message: "请输入生产厂商",
            trigger: "change",
          },
        ],
        drugType: [
          {
            required: true,
            message: "请选择药品类型",
            trigger: "change",
          },
        ],
        drugDosage: [
          {
            required: true,
            message: "请选择药品剂型",
            trigger: "change",
          },
        ],
        goodsUnit: [
          {
            required: true,
            message: "请输入最小计量单位",
            trigger: "change",
          },
        ],
        retailPrice: [
          {
            required: true,
            message: "请输入零售价格",
            trigger: "change",
          },
        ],
        minQuantity: [
          {
            required: true,
            message: "请输入起购数量",
            trigger: "change",
          },
        ],
        unitQuantity: [
          {
            required: true,
            message: "请输入单位数量",
            trigger: "change",
          },
        ],
        classifyIds: [
          {
            required: true,
            message: "请选择商品分类",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    randomSpuIdClick() {
      if (this.editModel && !this.editModel.tempSpuId) {
        this.editModel.tempSpuId = this.uuidv4();
      }
    },
    specDelLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    removeSpecClick(row) {
      if (!this.editModel.specGoodsList) {
        this.editModel.specGoodsList = [];
      }
      let indexOf = -1;
      this.editModel.specGoodsList.forEach((i, index) => {
        if (row.specSkuInfo && row.specSkuInfo.guid == i.specSkuGuid) {
          indexOf = index;
        } else if (row.guid == i.specSkuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.specGoodsList.splice(indexOf, 1);
      }
    },
    deleteSpecClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
    },
    getSpecItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.specGoodsList || []).forEach((item) => {
        if (item.specSkuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    handleAddSpecItem(item) {
      if (!this.editModel.specGoodsList) {
        this.editModel.specGoodsList = [];
      }
      let flag = false;
      this.editModel.specGoodsList.forEach((i) => {
        if (item.specSkuInfo && item.specSkuInfo.guid == i.specSkuGuid) {
          flag = true;
        } else if (i.specSkuGuid == item.guid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.specGoodsList.unshift({
          specSkuInfo: item,
          specSkuGuid: item.guid,
          specName: item.goodsSpec || "",
          isDelete: 0,
        });
      }
    },
    splitConsumeDelLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    removeSplitConsumeClick(row) {
      if (!this.editModel.splitConsumeList) {
        this.editModel.splitConsumeList = [];
      }
      let indexOf = -1;
      this.editModel.splitConsumeList.forEach((i, index) => {
        if (row.consumeSkuInfo && row.consumeSkuInfo.guid == i.consumeSkuGuid) {
          indexOf = index;
        } else if (row.guid == i.consumeSkuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.splitConsumeList.splice(indexOf, 1);
      }
    },
    deleteSplitConsumeClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
    },
    getSplitConsumeItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.splitConsumeList || []).forEach((item) => {
        if (item.consumeSkuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    handleAddSplitConsumeItem(item) {
      if (!this.editModel.splitConsumeList) {
        this.editModel.splitConsumeList = [];
      }
      let flag = false;
      this.editModel.splitConsumeList.forEach((i) => {
        if (item.consumeSkuInfo && item.consumeSkuInfo.guid == i.consumeSkuGuid) {
          flag = true;
        } else if (i.consumeSkuGuid == item.guid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.splitConsumeList.unshift({
          consumeSkuInfo: item,
          consumeSkuGuid: item.guid,
          outputCount: 1,
          isDelete: 0,
        });
      }
    },
    splitOutputDelLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    removeSplitOutputClick(row) {
      if (!this.editModel.splitOutputList) {
        this.editModel.splitOutputList = [];
      }
      let indexOf = -1;
      this.editModel.splitOutputList.forEach((i, index) => {
        if (row.outputSkuInfo && row.outputSkuInfo.guid == i.outputSkuGuid) {
          indexOf = index;
        } else if (row.guid == i.outputSkuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.splitOutputList.splice(indexOf, 1);
      }
    },
    deleteSplitOutputClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
    },
    getSplitOutputItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.splitOutputList || []).forEach((item) => {
        if (item.outputSkuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    handleAddSplitOutputItem(item) {
      if (!this.editModel.splitOutputList) {
        this.editModel.splitOutputList = [];
      }
      let flag = false;
      this.editModel.splitOutputList.forEach((i) => {
        if (item.outputSkuInfo && item.outputSkuInfo.guid == i.outputSkuGuid) {
          flag = true;
        } else if (i.outputSkuGuid == item.guid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.splitOutputList.unshift({
          outputSkuInfo: item,
          outputSkuGuid: item.guid,
          outputCount: 1,
          isDelete: 0,
        });
      }
    },
    submitClick() {
      return new Promise((resolve, reject) => {
        if (!this.$refs.formRef) {
          resolve();
        } else {
          this.$refs.formRef.validate((valid, data) => {
            if (valid) {
              resolve();
            } else {
              this.showValidate(data);
              reject();
            }
          });
        }
      }).then(() => {
        this.$refs.form.validate((valid, data) => {
          if (valid) {
            this.editSubmit = true;
            this.editModel.goodsName = this.editModel.goodsTitle;
            const method = this.editModel.guid
              ? "biz.goods.sku.info.update"
              : "biz.goods.sku.info.create";
            this.requestApi(method, this.editModel, {
              showError: true,
            })
              .then((resp) => {
                this.success("保存成功");
                this.$drawer.refreshDrawer();
                this.$drawer.backDrawer();
              })
              .finally(() => {
                this.editSubmit = false;
              });
          } else {
            this.showValidate(data);
          }
        });
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.copyTo) {
        Object.assign(this.editModel, this.pageParams.copyTo, {
          guid: "",
          bizUniqueId: "",
          goodsSpuCode: "",
          splitConsumeList: [],
          splitOutputList: [],
          specGoodsList: [],
        });
      }
      if (this.pageParams.classifyGuid) {
        this.editModel.classifyGuid = this.pageParams.classifyGuid;
      }
      this.fetchSpecGoodsList();
      this.fetchSplitOutputList();
      this.fetchSplitConsumeList();
    },
    fetchSplitConsumeList() {
      if (this.editModel && this.editModel.guid) {
        return this.requestApi("biz.goods.split.info.list", {
          outputSkuGuid: this.editModel.guid,
        }).then((listResp) => {
          this.editModel.splitConsumeList = (listResp.data.list || []).map((item) => {
            item.isDelete = 0;
            return item;
          });
        });
      } else {
        this.editModel.splitConsumeList = [];
      }
    },
    fetchSplitOutputList() {
      if (this.editModel && this.editModel.guid) {
        return this.requestApi("biz.goods.split.info.list", {
          consumeSkuGuid: this.editModel.guid,
        }).then((listResp) => {
          this.editModel.splitOutputList = (listResp.data.list || []).map((item) => {
            item.isDelete = 0;
            return item;
          });
        });
      } else {
        this.editModel.splitOutputList = [];
      }
    },
    fetchSpecGoodsList() {
      if (this.editModel && this.editModel.guid) {
        return this.requestApi("biz.goods.sku.info.specList", {
          guid: this.editModel.guid,
        }).then((listResp) => {
          this.editModel.specGoodsList = (listResp.data || []).map((item) => {
            item.isDelete = 0;
            return item;
          });
        });
      } else {
        this.editModel.specGoodsList = [];
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.goods.sku.info.detail", {
          guid: this.pageParams.guid,
        })
          .then((resp) => {
            this.editModel = Object.assign({}, defaultModel, resp.data);
            this.handleModel();
          })
          .catch((err) => {
            this.errorMsg =
              (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    updateSkuInfoByVetZsmClick() {
      if (!this.vetZsmInfo) {
        return;
      }
      if (!this.editModel) {
        return;
      }
      if (this.editModel.goodsType != "veterinary") {
        return;
      }
      Object.assign(this.editModel, {
        genericName: this.vetZsmInfo.genericName,
        drugName: this.vetZsmInfo.productName,
        drugSpec: this.vetZsmInfo.productSpec,
        drugDosage: this.vetZsmInfo.drugDosage,
        approvalNum: this.vetZsmInfo.approvalNum,
        manufacturer: this.vetZsmInfo.manufacturer,
      });
      this.vetZsmVisible = false;
    },
    getVetZsmInfo() {
      if (!this.editModel) {
        return;
      }
      if (this.editModel.goodsType != "veterinary") {
        return;
      }
      this.vetZsmInfo = null;
      this.vetZsmVisible = true;
      this.vetZsmErrorMsg = null;
      this.vetZsmLoading = true;
      return this.requestApi("biz.data.vet.zsm.info.query", {
        zsmCode: this.vetZsmCode,
      })
        .then((resp) => {
          this.vetZsmLoading = false;
          this.vetZsmInfo = resp.data;
        })
        .catch((err) => {
          this.vetZsmLoading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
